import { mapGetters } from 'vuex';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// QM §5.2 — authority for the queue screens comes from role permissions, not group membership.
export default {
  computed: {
    ...mapGetters({
      currentUserRole: 'getCurrentRole',
      currentAccountId: 'getCurrentAccountId',
    }),
    isQueueAdministrator() {
      return this.currentUserRole === 'administrator';
    },
    queuePermissions() {
      return this.$store.getters.getInboxPermissions || [];
    },
    // QM §5.5 — read: see the Queue Management button and open its screens.
    hasQueueSupervision() {
      return this.hasQueuePermission('Queues Management', 'can_read', false);
    },
    // QM §5.5 — update: act on the supervisor screen (assign, move, unlock, return).
    canActOnQueueSupervision() {
      return this.hasQueuePermission('Queues Management', 'can_update', false);
    },
    // QM §5.3 — read: see the Settings → Queues screen.
    canViewQueueSettings() {
      return this.hasQueuePermission('Queue Settings', 'can_read', true);
    },
    // QM §5.4 — read: see the agent Queues screen.
    canViewQueues() {
      return this.hasQueuePermission('Queues', 'can_read', true);
    },
    // QM §5.4.3 — update: Browse / Take next, plus the per-ticket actions in My tickets.
    canActOnQueues() {
      return this.hasQueuePermission('Queues', 'can_update', true);
    },
    isQueueManagementEnabled() {
      return this.$store.getters['accounts/isFeatureEnabledonAccount'](
        this.currentAccountId,
        FEATURE_FLAGS.QUEUE_MANAGEMENT
      );
    },
  },
  methods: {
    hasQueuePermission(name, flag, allowedWithoutCustomRoles) {
      if (this.isQueueAdministrator) {
        return true;
      }
      if (!this.queuePermissions.length) {
        return allowedWithoutCustomRoles;
      }
      const permission = this.queuePermissions.find(item => item.name === name);
      return !!permission && !!permission[flag];
    },
  },
};
